export default __webpack_public_path__ + "static/media/element_71.86bdcd54.webp";